export enum FieldTypes {
    boolean = 'boolean',
    string = 'string',
    integer = 'integer',
    float = 'float',
    dropdown = 'dropdown',
}
